import Modal from "../../../components/Modal"

const MessageConfirmDialog = ({ show, handleClose, onConfirm, title, body, confirmTheme="success", cancelText="ไม่", confirmText="ใช่" }) => {
  return <Modal show={show} onHide={handleClose}
    title={title}
    okAction={onConfirm}
    okText={confirmText}
    cancelText={cancelText}
    okTheme={confirmTheme}>
    {body}
  </Modal>
}

export default MessageConfirmDialog